import React, { Component, PropTypes } from 'react';

import './style.scss';

export class RepliesList extends Component {

  render() {
    return (
      <div className="RepliesList">
        {this.props.children}
      </div>
    );
  }
}

RepliesList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node)
};

export default RepliesList;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/RepliesList/index.js
 **/